/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable prefer-const */
/* eslint-disable prettier/prettier */
/* eslint-disable array-callback-return */
/* eslint-disable promise/always-return */
/* eslint-disable no-console */
/* eslint-disable unicorn/prefer-spread */
/* eslint-disable no-unused-vars */
/* eslint-disable no-var */
/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */
/**
 * @file Support Center
 *
 * Submit Article page related components initialization
 */
import Modal from '../../../components/Modal';
import Select from '../../../components/Select';
import SelectorEngine from '../../../utils/dom/selector-engine';
import EventHandler from '../../../utils/dom/event-handler';
import Request from '../../../utils/request';
import attachValidation from '../../../utils/form-validation';
import { getDataFromForm } from '../../../utils/misc';

const SELECTOR_FILE_UPLOAD_ALERT = '.js-alert-file-upload-dismiss';
const SELECTOR_CAPTCHA_ALERT = '.js-alert-captcha-dismiss';
const SELECTOR_API_ALERT = '.js-alert-api-dismiss';

const CLICK_EVENT = 'click';

class SubmitArticle {
	constructor() {
		this.state = {
			firstNameValue: undefined,
			lastNameValue: undefined,
			ltaNumberValue: undefined,
			dobValue: undefined,
			email: undefined,
			isLoggedin: undefined,
			phoneNumber: '',
			roles: [],
			topics: [],
			selectedRole: undefined,
			selectedTopic: undefined,
			uploadedFiles: [],
			info: undefined,
			loggedinContact: undefined,
			defaultErrorTitle: '',
			captchaErrorTitle: '',
			apiErrorTitle: '',
			fileUploadErrorTitle: '',
			formSubmittingText: '',
			maxFileSizeErrorTitle: ''
		};
		this._mainWrapper = SelectorEngine.findOne('.support-center-form-wrapper');
		this.formValidationInstance = undefined;
		this.submitArticleBtn = undefined;
		this.errorMaxFileUpload = undefined;
		if (!this._mainWrapper) {
			return;
		}
		this.init();
	}

	get rolesData() {
		return this._roles;
	}
	set rolesData(roles = []) {
		this._roles = roles;
		this._updateRoles();
	}

	get topicsData() {
		return this._topics;
	}
	set topicsData(topics = []) {
		this._topics = topics;
		this._updateTopics();
	}

	init() {
		this.loadPrimaryRoles();
		this.loadTopics();
		this._formWrapper = SelectorEngine.findOne('.lta-submit-enquiry', this._mainWrapper);
		this._articleSubmitted = SelectorEngine.findOne('.article-form-submitted', this._mainWrapper);
		this.submitArticleForm = SelectorEngine.findOne('#submitEnquiry', this._formWrapper);
		this.firstNameEl = SelectorEngine.findOne('#firstName', this.submitArticleForm);
		this.firstNameErrorEl = SelectorEngine.findOne('.lta-text-input--error', this.firstNameEl);
		this.lastNameEl = SelectorEngine.findOne('#lastName', this.submitArticleForm);
		this.fnlnContainer = SelectorEngine.findOne('.sc-name-container', this._formWrapper);
		this.emailEl = SelectorEngine.findOne('#email', this.submitArticleForm);
		this.confirmEmailEl = SelectorEngine.findOne('#confirmEmail', this.submitArticleForm);
		this.phoneNumber = SelectorEngine.findOne('#phone', this.submitArticleForm);
		this.info = SelectorEngine.findOne('#info', this.submitArticleForm);
		this.loggedinUserContainer = SelectorEngine.findOne('.sc-loggedin-user-container', this._formWrapper);
		this.nocaptchaError = SelectorEngine.findOne('.sc-no-captcha--error', this._formWrapper);
		this.submitApiError = SelectorEngine.findOne('.submit-article__submit-api-error', this._formWrapper);

		// Data Attributes for logged in user
		this.state.firstNameValue = this.submitArticleForm.getAttribute('data-sc-first-name');
		this.state.lastNameValue = this.submitArticleForm.getAttribute('data-sc-last-name');
		this.state.ltaNumberValue = this.submitArticleForm.getAttribute('data-sc-lta-number');
		this.state.dobValue = this.submitArticleForm.getAttribute('data-sc-dob');
		this.state.email = this.submitArticleForm.getAttribute('data-sc-email');
		this.state.phoneNumber = this.submitArticleForm.getAttribute('data-sc-mobile');
		this.state.isLoggedin = this.isLoggedInUser(this.submitArticleForm.getAttribute('data-sc-isLoggedin'));
		this.state.loggedinContact = this.submitArticleForm.getAttribute('data-sc-contactId');
		this.state.defaultErrorTitle = this.submitArticleForm.getAttribute('data-error-default');
		this.state.captchaErrorTitle = this.submitArticleForm.getAttribute('data-captcha-error');
		this.state.apiErrorTitle = this.submitArticleForm.getAttribute('data-api-error');
		this.state.fileUploadErrorTitle = this.submitArticleForm.getAttribute('data-file-upload-error');
		this.state.formSubmittingText = this.submitArticleForm.getAttribute('data-submit-enquiry-text');
		this.state.maxFileSizeErrorTitle = this.submitArticleForm.getAttribute('data-max-file-upload-error-title');

		this.formValidationInstance = attachValidation(this.submitArticleForm, {
			firstName: {
				validators: {
					notEmpty: {
						message: 'Please enter a first name'
					},
					regexp: {
						regexp: /^[^0-9?!\"£$%^&*()=+{}@:;~<>\\]+$/,
						message: 'Please enter a valid first name'
					}
				}
			},
			lastName: {
				validators: {
					notEmpty: {
						message: 'Please enter a last name'
					},
					regexp: {
						regexp: /^[^0-9?!\"£$%^&*()=+{}@:;~<>\\]+$/,
						message: 'Please enter a valid last name'
					}
				}
			},
			emailAddress: {
				validators: {
					notEmpty: {
						message: 'Please enter an email address'
					},
					regexp: {
						regexp:
							// eslint-disable-next-line no-useless-escape
							/^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\da-z\-]+\.)+[a-z]{2,}))$/i,
						message: 'Please enter a valid email address'
					}
				}
			},
			confirmEmailAddress: {
				validators: {
					identical: {
						compare: () => form.querySelector('[name="emailAddress"]').value,
						message: 'Email address does not match'
					},
					regexp: {
						regexp: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
						message: 'Please enter a valid email address'
					}
				}
			},
			phone: {
				validators: {
					numeric: {
						message: 'Please enter valid phone number'
					}
				}
			},
			// Commenting the restrictions for now until we hear back on #31622
			// info: {
			// 	validators: {
			// 		notEmpty: {
			// 			message: 'Please enter detailed information for your query'
			// 		},
			// 		regexp: {
			// 			regexp: /^[a-zA-Z0-9\s,.\-#/]{1,320}$/,
			// 			message: 'Please enter a valid access requirement'
			// 		}
			// 	}
			// },
			ltaNumber: {
				validators: {
					regexp: {
						regexp: /^\d{1,12}$/,
						message: 'Please enter a valid LTA number'
					}
				}
			},
			yourRole: {
				validators: {
					notEmpty: {
						message: 'Please select your role'
					}
				}
			},
			topic: {
				validators: {
					notEmpty: {
						message: 'Please select the topic of enquiry'
					}
				}
			}
		})
			.on('core.form.valid', () => {
				this.submitArticleBtn.disabled = true;
				this.submitArticleLoader.classList.remove('u-hidden');
				this.submitArticleText.innerHTML = this.state.formSubmittingText;
				this.submitArticleBtn.classList.add('upload-loading');
				errorFieldsContainer.classList.add('u-hidden');
				const captchaResponse = grecaptcha.getResponse();
				if (captchaResponse.length > 0) {
					grecaptcha.reset();

					if (
						this.state.isLoggedin &&
						(this.state.email !== this.emailEl.value || this.state.phoneNumber !== this.phoneNumber.value)
					) {
						this.triggerUpdateDetails(this.submitArticleForm);
					} else {
						this.submitEnquiry(this.submitArticleForm);
					}
				} else {
					this.nocaptchaError.classList.remove('u-hidden');
					this.submitArticleBtn.disabled = false;
					this.submitArticleLoader.classList.add('u-hidden');
					const capthaErrorsList = this.nocaptchaError.querySelector('ul');
					capthaErrorsList.textContent = this.state.captchaErrorTitle;
					this.nocaptchaError.querySelector('.lta-snackbar__label.title').innerHTML = this.state.defaultErrorTitle;
					this.nocaptchaError.scrollIntoView();
				}
			})
			.on('core.field.valid', (name) => {
				const invalidField = document.getElementsByName(name)[0];
				const invalidFieldType = invalidField.getAttribute('type');
				const fieldWrapper = invalidField.closest(ValidationUtils.getFieldWrapper(invalidFieldType));
				fieldWrapper.classList.remove(...ValidationUtils.getErrorClasses(invalidFieldType));

				// remove error messages that are now valid
				const errorMessages = SelectorEngine.find(`.js-validation-${name}`, fieldsErrorsList);
				if (errorMessages) {
					[...errorMessages].forEach((element) => {
						element.remove();
					});
				}

				// if there are no more error messages, remove error messages container
				if (fieldsErrorsList.children.length === 0) {
					errorFieldsContainer.classList.add('u-hidden');
				}
			})
			.on('core.form.invalid', () => {
				this.submitArticleBtn.disabled = false;
				this.submitArticleText.innerHTML = 'Submit Enquiry';
				this.submitArticleLoader.classList.add('u-hidden');
				errorFieldsContainer.classList.remove('u-hidden');
				errorFieldsContainer.scrollIntoView();
			})
			.on('core.form.validating', () => {
				fieldsErrorsList.textContent = '';
			})
			.on('plugins.message.displayed', (e) => {
				// checks if error message isn't already added
				if (!SelectorEngine.findOne(`.js-validation-${e.field}--${e.validator}`, fieldsErrorsList)) {
					const listItem = document.createElement('li');
					const listSpan = document.createElement('span');
					const listLink = document.createElement('a');
					listLink.setAttribute('href', '#');
					listItem.setAttribute('class', `js-validation-${e.field} js-validation-${e.field}--${e.validator}`);
					listLink.append(document.createTextNode(e.message));
					listSpan.append(listLink);
					listItem.append(listSpan);

					fieldsErrorsList.append(listItem);

					listLink.addEventListener('click', (event) => {
						event.preventDefault();
						scrollToNode(e.element);
						e.element.focus();
					});
				}
			});

		const yourRole = SelectorEngine.findOne('.submit-article__your-role .js-lta-select', this._formWrapper);
		this.yourRoleElement = Select.getInstance(yourRole) || new Select(yourRole);
		EventHandler.on(this.yourRoleElement._selectNativeElement, 'change', this.roleValidation.bind(this));

		const topic = SelectorEngine.findOne('.submit-article__submit-enquiry-topic .js-lta-select', this._formWrapper);
		this.topicElement = Select.getInstance(topic) || new Select(topic);
		EventHandler.on(this.topicElement._selectNativeElement, 'change', this.topicValidation.bind(this));

		const errorFieldsContainer = this._formWrapper.querySelector('.form-fields-error-container');
		const errorFieldsWrapper = errorFieldsContainer.querySelector('.submit-enquiry--fields-container');
		const fieldsErrorsList = errorFieldsWrapper.querySelector('ul');
		fieldsErrorsList.textContent = '';

		this.roleCodeContainer = SelectorEngine.findOne('.sc-code-container', this._formWrapper);
		this.submitArticleBtn = SelectorEngine.findOne('.submit-article__btn', this.submitArticleForm);
		this.submitArticleText = SelectorEngine.findOne('.js-article-submit-text', this.submitArticleForm);
		this.submitArticleLoader = SelectorEngine.findOne('.js-article-submit-loader', this.submitArticleForm);
		const updateDetailsButton = SelectorEngine.findOne('.update-details-btn', this._formWrapper);
		const noUpdateDetailsButton = SelectorEngine.findOne('.no-update-details-btn', this._formWrapper);
		this.errorMaxFileUpload = SelectorEngine.findOne(
			'.submit-article__maxfile-upload-error-desktop',
			this._formWrapper
		);
		this.fileInput = SelectorEngine.findOne('#inputFile', this._formWrapper);
		const uploadButton = SelectorEngine.findOne('.js-upload-btn', this._formWrapper);

		this.dismissAlert = SelectorEngine.findOne(SELECTOR_FILE_UPLOAD_ALERT, this.errorMaxFileUpload);
		this.dismissCaptchaAlert = SelectorEngine.findOne(SELECTOR_CAPTCHA_ALERT, this.nocaptchaError);
		this.dismissApiAlert = SelectorEngine.findOne(SELECTOR_API_ALERT, this.submitApiError);

		EventHandler.on(this.phoneNumber, 'change', (e) => {
			if (!this.state.isLoggedin) {
				this.phoneNumber.value = e.target.value;
				this.state.phoneNumber = e.target.value;
			}
		});

		EventHandler.on(this.info, 'change', (e) => {
			var myJSONString = JSON.stringify(e.target.value);
			this.state.info = myJSONString
				.replace(/\\n/g, '\\n')
				.replace(/\\'/g, "\\'")
				.replace(/\\"/g, '\\"')
				.replace(/\\&/g, '\\&')
				.replace(/\\r/g, '\\r')
				.replace(/\\t/g, '\\t')
				.replace(/\\b/g, '\\b')
				.replace(/\\f/g, '\\f');
		});

		EventHandler.on(this.dismissAlert, CLICK_EVENT, () => {
			this.dismissAlertClickHandler();
		});

		EventHandler.on(this.dismissCaptchaAlert, CLICK_EVENT, () => {
			this.dismissAlertCaptchaHandler();
		});

		EventHandler.on(this.dismissApiAlert, CLICK_EVENT, () => {
			this.dismissAlertApiAlert();
		});

		if (this.state.isLoggedin) {
			SelectorEngine.findOne('.confirm-email-container', this._formWrapper).classList.remove('u-hidden');
		} else {
			SelectorEngine.findOne('.confirm-email-container', this._formWrapper).classList.add('u-hidden');
		}

		EventHandler.on(this.emailEl, 'change', (e) => {
			if (!this.state.isLoggedin) {
				this.confirmEmailEl.value = e.target.value;
				this.state.email = e.target.value;
			}
		});

		if (this.state.firstNameValue && this.state.lastNameValue) {
			this.fnlnContainer.classList.add('u-hidden');
			this.loggedinUserContainer.classList.remove('u-hidden');
			this.firstNameEl.value = this.state.firstNameValue;
			this.lastNameEl.value = this.state.lastNameValue;
			SelectorEngine.findOne('.loggedin-fname', this.loggedinUserContainer).innerHTML = this.state.firstNameValue;
			SelectorEngine.findOne('.loggedin-lname', this.loggedinUserContainer).innerHTML = this.state.lastNameValue;
			SelectorEngine.findOne('.loggedin-dob', this.loggedinUserContainer).innerHTML = this.state.dobValue;
		} else {
			this.fnlnContainer.classList.remove('u-hidden');
			this.loggedinUserContainer.classList.add('u-hidden');
		}

		if (this.state.ltaNumberValue) {
			SelectorEngine.findOne('.loggedin-ltaNumber', this.loggedinUserContainer).innerHTML = this.state.ltaNumberValue;
			SelectorEngine.findOne('.sc-lta-number-container', this._formWrapper).classList.add('u-hidden');
		} else {
			SelectorEngine.findOne('.sc-lta-number-container', this._formWrapper).classList.remove('u-hidden');
		}

		if (this.state.email) {
			if (
				this.emailEl.parentElement.querySelector('.lta-text-input__label-instruction').classList.contains('u-hidden')
			) {
				this.emailEl.parentElement.querySelector('.lta-text-input__label-instruction').classList.remove('u-hidden');
			}
			this.emailEl.value = this.state.email;
			this.confirmEmailEl.value = this.state.email;
		} else {
			this.emailEl.parentElement.querySelector('.lta-text-input__label-instruction').classList.add('u-hidden');
		}

		if (this.state.phoneNumber) {
			this.phoneNumber.value = this.state.phoneNumber;
		}

		setTimeout(() => {
			this.yourRoleWrapper = SelectorEngine.findOne('.submit-article-wrapper-role', this._formWrapper);
			this.yourRoleErrorElement = SelectorEngine.findOne('.lta-text-input--error', this.yourRoleWrapper);

			this.topicWrapper = SelectorEngine.findOne('.submit-article-topic-wrapper-role', this._formWrapper);
			this.topicErrorElement = SelectorEngine.findOne('.lta-text-input--error', this.topicWrapper);
		}, 1500);

		EventHandler.on(uploadButton, 'click', () => {
			this.fileInput.click();
		});

		EventHandler.on(this.fileInput, 'change', () => {
			const selectedFiles = Array.from(this.fileInput.files);
			const ul = document.createElement('ul');
			SelectorEngine.findOne('.uploaded-file-name', this._formWrapper).append(ul);
			if (selectedFiles.concat(this.state.uploadedFiles).length < 5) {
				selectedFiles.map((index, v) => {
					const fileSize = index.size / 1024 / 1024;
					if (fileSize > 5) {
						this.showUploadError(this.state.maxFileSizeErrorTitle);
					} else {
						const li = document.createElement('li');
						li.classList.add('uploaded-file-list');
						li.setAttribute('id', `remove-uploaded-item-${v}`);
						li.addEventListener(
							'click',
							(event) => {
								this.removeUploadedItems(event.currentTarget, this.state.uploadedFiles, v);
							},
							false
						);
						const div1 = document.createElement('div');
						div1.innerHTML = index.name;
						// eslint-disable-next-line unicorn/prefer-dom-node-append
						li.appendChild(div1);
						li.innerHTML +=
							'<button type="button" class="lta-btn lta-btn--default lta-btn--link lta-btn--icon u-ml-3 lta-btn--icon-before"><svg width="1.8em" height="1.8em" viewBox="0 0 24 24" class="lta-icon lta-icon__close" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g><g fill="currentColor"><path d="M6 0H9V14H6z" transform="rotate(45 3.714 14.932) rotate(90 7.5 7)"/><path d="M6 0H9V14H6z" transform="rotate(45 3.714 14.932)"/></g><path d="M0 0H24V24H0z"/></g></g></svg></button>';
						ul.append(li);
						this.state.uploadedFiles.push(index);
					}
				});
			} else {
				this.showUploadError(this.state.fileUploadErrorTitle);
			}
		});

		EventHandler.on(updateDetailsButton, 'click', () => {
			this._updateDetailsModal.hide();
			this.updateUserDetails();
		});

		EventHandler.on(noUpdateDetailsButton, 'click', () => {
			this._updateDetailsModal.hide();
			this.submitEnquiry(this.submitArticleForm);
		});
	}

	removeUploadedItems(event, files, index) {
		event.remove();
		const fileArray = Array.from(files);
		if (index > -1) {
			// only splice array when item is found
			fileArray.splice(index, 1); // 2nd parameter means remove one item only
		}
		this.state.uploadedFiles = fileArray;
	}

	isLoggedInUser(value) {
		return value === 'true' ? true : false;
	}

	_updateRoles() {
		this.yourRoleElement.clearItems();
		const element = SelectorEngine.findOne('select', this.yourRoleElement._element);
		const options = [
			`<option value="" disabled="" selected="">- Please select -</option>`,
			...Object.keys(this.rolesData).map((index) => {
				const roles = this.rolesData[index];
				return `<option value="${roles.value}" ${roles.value === element.value ? 'selected' : ``}>
							${roles.value}
						</option>`;
			})
		].join('');
		element.innerHTML = options;
		this.yourRoleElement.generateItems();
	}

	_updateTopics() {
		this.topicElement.clearItems();
		const element = SelectorEngine.findOne('select', this.topicElement._element);
		const options = [
			`<option value="" disabled="" selected="">- Please select -</option>`,
			...Object.keys(this.topicsData).map((index) => {
				const topics = this.topicsData[index];
				return `<option value="${topics.value}" ${topics.value === element.value ? 'selected' : ``}>
							${topics.value}
						</option>`;
			})
		].join('');
		element.innerHTML = options;
		this.topicElement.generateItems();
	}

	async loadPrimaryRoles() {
		await Request.get('/api/Enquiry/GetPrimaryRoles')
			.catch((error) => {
				console.error(error);
			})
			.then((response) => {
				this.state.roles = response.PrimaryRoles;
				this.rolesData = this.state.roles;
			});
	}

	async loadTopics() {
		await Request.get('/api/Enquiry/GetTopicOfEnquiry')
			.catch((error) => {
				console.error(error);
			})
			.then((response) => {
				this.state.topics = response.TopicOfEnquiryList;
				this.topicsData = this.state.topics;
			});
	}

	async submitEnquiry(form) {
		const dataObject = getDataFromForm(form);
		const role = this.state.selectedRole?.toLowerCase();
		const formData = new FormData();

		const finalData = Object.assign(
			{},
			{
				membershipRole: dataObject.yourRole,
				email: this.state.email,
				firstname: this.state.isLoggedin ? this.state.firstNameValue : dataObject.firstName,
				lastname: this.state.isLoggedin ? this.state.lastNameValue : dataObject.lastName,
				category: this.state.selectedTopic,
				[role + 'Code']: dataObject[role + 'Code'] || '',
				phone: this.state.isLoggedin ? this.state.phoneNumber : dataObject.phone,
				ltaNumber: this.state.isLoggedin ? this.state.ltaNumberValue : dataObject.ltaNumber,
				dateOfBirth: this.state.isLoggedin ? this.state.dobValue : '',
				info: this.state.info
			}
		);
		formData.append('json', JSON.stringify(finalData));
		formData.append('cid', this.state.loggedinContact);
		this.state.uploadedFiles &&
			Object.keys(this.state.uploadedFiles).map((index, v) => {
				formData.append(`attachment${v}`, this.state.uploadedFiles[index]);
			});

		await Request.postFormData('/api/Enquiry/SubmitEnquiry', formData)
			.catch((error) => {
				console.log(error);
				this.submitArticleBtn.classList.remove('loading');
				this.submitArticleText.innerHTML = 'Submit enquiry';
			})
			.then((data) => {
				if (data === undefined) {
					this.showApiError(this.state.apiErrorTitle);
					this.submitArticleBtn.disabled = false;
				} else if (data.StatusCode == '02') {
					this._formWrapper.classList.add('u-hidden');
					this._articleSubmitted.classList.remove('u-hidden');
					this._articleSubmitted.scrollIntoView();
				} else {
					this.showApiError(this.state.apiErrorTitle);
					this.submitArticleBtn.disabled = false;
				}
				this.submitArticleLoader.classList.add('u-hidden');
				this.submitArticleText.innerHTML = 'Submit enquiry';
			});
	}

	async updateUserDetails() {
		let payload = {
			emailAddress: this.state.email,
			phoneNumber: this.state.phoneNumber
		};
		await Request.post('/api/Enquiry/UpdateContactDetails', payload)
			.catch((error) => {
				console.error(error);
			})
			.then((data) => {
				if (data.StatusCode == '02') {
					this.submitEnquiry(this.submitArticleForm);
				} else {
					this.showApiError(this.state.apiErrorTitle);
					this.submitArticleBtn.disabled = false;
				}
			});
	}

	triggerUpdateDetails(form) {
		if (this.state.isLoggedin) {
			this._updateDetailsModal = new Modal(document.querySelector('#js-update-details-modal'), {});
			this._updateDetailsModal.show();
			this.state.email = this.emailEl.value;
			this.state.phoneNumber = this.phoneNumber.value;
		} else {
			this.submitEnquiry(form);
		}
	}

	dismissAlertClickHandler() {
		this.errorMaxFileUpload.classList.add('u-hidden');
		this.fileInput.value = '';
	}

	dismissAlertCaptchaHandler() {
		this.nocaptchaError.classList.add('u-hidden');
	}

	dismissAlertApiAlert() {
		this.submitApiError.classList.add('u-hidden');
	}

	showUploadError(title) {
		this.errorMaxFileUpload.classList.remove('u-hidden');
		const errorList = this.errorMaxFileUpload.querySelector('ul');
		errorList.textContent = title;
		this.errorMaxFileUpload.querySelector('.lta-snackbar__label.title').innerHTML = this.state.defaultErrorTitle;
		this.errorMaxFileUpload.scrollIntoView();
	}

	showApiError(title) {
		this.submitApiError.classList.remove('u-hidden');
		this.submitApiError.querySelector('.lta-snackbar__label.title').innerHTML = title;
		this.submitApiError.scrollIntoView();
	}

	roleValidation() {
		const roleValue = this.yourRoleElement._selectNativeElement.value;
		this.state.selectedRole = roleValue;

		const filteredRole = this.rolesData.find((role) => role.value == roleValue);
		if (filteredRole?.IsTextBox === true) {
			this.roleCodeContainer.classList.remove('u-hidden');
			this.roleCodeContainer.firstElementChild.children[0].innerHTML = filteredRole?.value + ' Code (Optional)';
			this.roleCodeContainer.firstElementChild.children[2].setAttribute(
				'id',
				filteredRole?.value.toLowerCase() + 'Code'
			);
			this.roleCodeContainer.firstElementChild.children[2].setAttribute(
				'name',
				filteredRole?.value.toLowerCase() + 'Code'
			);
		} else {
			this.roleCodeContainer.classList.add('u-hidden');
		}
	}

	topicValidation() {
		const topicValue = this.topicElement._selectNativeElement.value;
		this.state.selectedTopic = topicValue;
	}
}

const submitArticle = new SubmitArticle();

export default submitArticle;
